import { useState } from "react";

const CurrencyConverterContentSix = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "How often are exchange rates updated?",
      text: `Rates are refreshed in real time using data from top global liquidity providers.`,
    },
    {
      title: "Can I convert cryptocurrencies as well?",
      text: `Yes, The Pips Currency Converter includes popular crypto pairs such as BTC/USD and ETH/EUR.`,
    },
    {
      title: "Is it free to use?",
      text: `Absolutely. The converter is available to all users free of charge.`,
    },
    {
      title: "How accurate are the conversion results?",
      text: `The tool provides precision-based results that mirror live market rates.`,
    },
    {
      title: "Can I use it for multiple conversions at once?",
      text: `Yes, you can switch between multiple currency pairs seamlessly for comparison.`,
    },
    // {
    //   title: "Does it include historical exchange data?",
    //   text: `Historical data can be accessed through our Tick History tool for deeper analysis.`,
    // },
    // {
    //   title: "Is the converter mobile-friendly?",
    //   text: `Yes, you can access it through our responsive web platform or The Pips app.`,
    // },
  ];

  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE IMAGE + TEXT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Why Accuracy Matters in Currency Conversion</h2>
              <p>
                A few cents can make a big difference in trading and
                international transfers. The Pips Currency Converter ensures you
                always know the real value of your money before making
                decisions, empowering you to act fast and with precision.
              </p>
            </div>
            <div className="thumb-left">
              <img
                src={process.env.PUBLIC_URL + "/images/resources/currency_converter/currency_converter_4.png"}
                alt="computer images"
              />
            </div>
          </div>

          {/* RIGHT SIDE ACCORDION */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <hr className="black-line" />
              {sections.map((section, index) => (
                <div key={index} className="accordion-section">
                  <button
                    className="accordion-header"
                    onClick={() => toggleSection(index)}
                  >
                    <h3>{section.title}</h3>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{section.text}</p>
                  </div>

                  <hr className="black-line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyConverterContentSix;
